
import { mapMutations, mapState } from 'vuex';

import Product from '@/components/shop/product.vue';
import LoadMore from '@/components/ui/loadMore.vue';
import Breadcrumbs from '@/components/shop/breadcrumbs.vue';
import Sort from '@/components/shop/sort.vue';
import Block from '@/components/ui/block.vue';

export default {
  name: 'CategoryPage',

  components: {
    Product,
    LoadMore,
    Breadcrumbs,
    Sort,
    Block,
  },

  layout: 'cat',

  fetch() {
    this.category = this.$store.getters.getCategoryBySlug(
      this.$route.params.slug
    );
  },

  data() {
    return {
      page: 1,
      lastPage: null,
      perPage: 12,
      loading: false,
      category: null,
      sortOpen: false,
      showText: false,
      visibleIds: [],
    };
  },

  computed: {
    ...mapState(['categories', 'sortName', 'products']),

    filteredProducts() {
      return this.$store.getters.filterProducts(this.categoryProducts);
    },

    sortedProducts() {
      // eslint-disable-next-line
      return this.$store.getters.sortProducts(this.filteredProducts);
    },

    visibleProducts() {
      return this.sortedProducts.filter((p) => this.visibleIds.includes(p.id));
    },

    categoryProducts() {
      if (this.hasChildren) {
        return [
          ...this.products.filter((p) =>
            p.categories
              .map((c) => c.id)
              .some((c) => this.childrenCategories.map((c) => c.id).includes(c))
          ),
        ];
      } else {
        return [
          ...this.products.filter((p) =>
            p.categories.map((c) => c.id).includes(this.category.id)
          ),
        ];
      }
    },

    hasChildren() {
      return Boolean(this.childrenCategories.length);
    },

    childrenCategories() {
      return this.categories.filter((c) => c.parent === this.category.id);
    },
  },

  async mounted() {
    if (this.category) {
      try {
        await this.getProducts();
      } catch (_) {
        return this.$nuxt.error({ statusCode: 404 });
      }
    }
  },

  methods: {
    ...mapMutations(['setProducts']),

    closeSort() {
      this.sortOpen = false;
    },

    async getProducts() {
      this.loading = true;
      const { data, headers } = await this.$wc.products({
        perPage: this.perPage,
        page: this.page,
        category: this.category.id,
      });
      this.loading = false;
      if (data && data.length) {
        this.visibleIds = [...this.visibleIds, ...data.map((p) => p.id)];
        this.visibleIds.filter(
          (value, index, array) =>
            array.findIndex((p) => p.id === value.id) === index
        );
        this.setProducts(data);
        if (headers['x-wp-totalpages']) {
          this.lastPage = parseInt(headers['x-wp-totalpages']);
          if (this.visibleProducts.length < 9 && this.lastPage > this.page) {
            this.getProducts();
          }
        }
        this.page++;
      }
    },
  },

  head() {
    if (this.category) {
      return this.$seo.yoast(this.category.yoast_head_json);
    }
  },
};
